import { Box } from '@hivebrite/design-system/Box';
import { Image } from '@hivebrite/design-system/Image';
import { DefaultLink } from '@hivebrite/design-system/Link';
import { useTheme } from '@hivebrite/design-system/Theme';

import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import AttachedFiles from 'hb-react/shared/components/DesignSystem/AttachedFiles';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import Landing from '../Landing';
import LandingContent from '../Landing/Content';

const NetworkNews = () => {
  const { attachments, externalUrl, postContent, title, coverPicture } =
    useLandingContext();
  const { currentNetwork } = useDefaultAppContexts();
  const theme = useTheme();
  const { flagEvNewsRevamp } = useFeatureFlag();
  const commentsEnabled =
    currentNetwork?.network_configuration?.news?.comments_enabled;

  return (
    <Landing
      title={
        flagEvNewsRevamp
          ? __(`created a <strong>news</strong>`)
          : __(`created a <strong>communication</strong>`)
      }
      titleDetailsForScreenReader={title}
      commentsEnabled={commentsEnabled}
    >
      {coverPicture?.wide_url && (
        <Box mt={4}>
          <Image
            mt={4}
            src={coverPicture.wide_url}
            width="100%"
            style={{
              borderRadius: theme.themeVariables.globalBorderRadius,
              aspectRatio: '630/239',
              objectFit: 'cover',
            }}
          />
        </Box>
      )}
      <Box font="h4-semibold" mt={6}>
        {title}
      </Box>
      <LandingContent content={postContent} mt={4} />
      {externalUrl && (
        <Box my={6}>
          <DefaultLink href={externalUrl} target="_blank">
            {s__('News|Continue reading in website')}
          </DefaultLink>
        </Box>
      )}
      {attachments?.length > 0 && <AttachedFiles attachedFiles={attachments} />}
    </Landing>
  );
};

export default NetworkNews;
